import type { AdminCrewReportBulkRequestHeaderProps } from "../../models/admin-crew-report.models";
import type { KeyboardEvent } from "react";

const stopGridKeyboardHandling = (event: KeyboardEvent<HTMLButtonElement>) => {
  if (event.key === "Enter" || event.key === " ") event.stopPropagation();
};

const AdminCrewReportBulkRequestHeader = ({
  controlsDisabled,
  hasSelection,
  hasFilteredRows,
  onBulkRequest,
  onToggleAll,
}: AdminCrewReportBulkRequestHeaderProps) => (
  <div className="min-w-0">
    <button
      type="button"
      disabled={controlsDisabled || !hasSelection}
      className="flex h-5 w-full items-center justify-center font-semibold text-[#005474] hover:text-green disabled:cursor-not-allowed disabled:opacity-50 dark:text-teal-300"
      data-test="admin-crew-report-open-bulk-request"
      onClick={onBulkRequest}
      onKeyDown={stopGridKeyboardHandling}
    >
      Bulk Request
    </button>
    <button
      type="button"
      disabled={controlsDisabled || (!hasSelection && !hasFilteredRows)}
      className="mt-1 flex h-6 w-full items-center justify-center text-[10px] font-normal text-[#005474] hover:text-green disabled:cursor-not-allowed disabled:opacity-50 dark:text-teal-300"
      data-test="admin-crew-report-toggle-all-bulk-requests"
      onClick={onToggleAll}
      onKeyDown={stopGridKeyboardHandling}
    >
      {hasSelection ? "Deselect All" : "Select All"}
    </button>
  </div>
);

export default AdminCrewReportBulkRequestHeader;
